import Interactable from 'Component/Interactable';
import BaseCard from './BaseCard';
import { CardType } from './CardType';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import Game from 'Game';

export default class ZapCard extends BaseCard {
    public onCreate(params: any): void {
        params.cardFrontTexture = 'scythe_card';
        params.type = CardType.zap;
        params.dragonbonesName = 'scythe';
        params.armatureName = 'scythe_card';
        params.armatureObjectName = 'scythe_armature';
        params.forceHideArmature = true;
        super.onCreate(params);
        const localBounds = this.find(BaseCard.CARD_BACK_NAME).container.getLocalBounds();
        this.getComponent(Interactable).hitArea = localBounds;
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('scythe', `${CARD_DRAGONBONES_PATH}/Scythe/`);
        return Game.resource.load();
    }
}
